import React from 'react';
import {Grid} from '@material-ui/core';
import {
    AutocompleteInput,
    FormDataConsumer,
    maxLength,
    ReferenceInput,
    required,
    TextInput,
    translate
} from 'react-admin';

const maxLen50 = maxLength(50, 'Không quá 50 ký tự');
const requiredTrim = Object.assign(
    (value, values, props) =>
        typeof value === 'string' && !value.trim()
            ? props.translate('ra.validation.required', { _: 'ra.validation.required' })
            : required()(value, values, props),
    { isRequired: true }
);

const styles = {
    label: { fontWeight: 'bold', marginBottom: 8, display: 'inline-block' },
    width90: { width: '90%' }
};

const Address = translate(({ prefixField = '', onChange,onDirectChange, translate, inputField = true }) => {
    return (
        <Grid container spacing={16}>
            <FormDataConsumer>
                {({ formData, ...rest }) => (
                    <>
                        <Grid item xs={12}>
                            <span style={styles.label}>
                                {translate(`resources.admissions.fields.${prefixField || 'address'}`)}
                            </span>
                        </Grid>

                        {/* City */}
                        <Grid item xs={12} sm={4}>
                            <ReferenceInput
                                source={`${prefixField}City`}
                                label="resources.admissions.fields.city"
                                reference="provinces"
                                onChange={(e, value) => {
                                    onDirectChange(`${prefixField}City`, value);
                                    onDirectChange(`${prefixField}Ward`, null)
                                }}
                                perPage={100}
                                validate={required()}
                                {...rest}
                            >
                                <AutocompleteInput optionText="name" />
                            </ReferenceInput>
                        </Grid>

                        {/* Ward - depends on province */}
                        <Grid item xs={12} sm={4}>
                            <ReferenceInput
                                key={`${prefixField}-ward-${formData[`${prefixField}City`] || 'no-city'}`}
                                source={`${prefixField}Ward`}
                                label="resources.admissions.fields.ward"
                                reference="wards"
                                onChange={(e, value) =>  {
                                    onDirectChange(`${prefixField}Ward`, value)}
                                }
                                filter={{
                                    provinceId: formData[`${prefixField}City`]
                                }}
                                disabled={!formData[`${prefixField}City`]}
                                validate={required()}
                                {...rest}
                            >
                                <AutocompleteInput optionText="name" />
                            </ReferenceInput>
                        </Grid>

                        {inputField &&
                            <>
                                {/* Cluster */}
                                <Grid item xs={12} sm={4}>
                                    <TextInput
                                        source={`${prefixField}Cluster`}
                                        label="resources.admissions.fields.cluster"
                                        onChange={onChange(`${prefixField}Cluster`)}
                                        style={styles.width90}
                                        validate={[requiredTrim, maxLen50]}
                                    />
                                </Grid>

                                {/* House No */}
                                <Grid item xs={12} sm={4}>
                                    <TextInput
                                        source={`${prefixField}HouseNo`}
                                        label="resources.admissions.fields.houseNo"
                                        onChange={onChange(`${prefixField}HouseNo`)}
                                        style={styles.width90}
                                        validate={[requiredTrim, maxLen50]}
                                    />
                                </Grid>

                                {/* Street */}
                                <Grid item xs={12} sm={4}>
                                    <TextInput
                                        source={`${prefixField}Street`}
                                        label="resources.admissions.fields.street"
                                        onChange={onChange(`${prefixField}Street`)}
                                        style={styles.width90}
                                        validate={[requiredTrim, maxLen50]}
                                    />
                                </Grid>
                            </>
                        }

                    </>
                )}
            </FormDataConsumer>
        </Grid>
    );
});

export default Address;
